import Box from '@mui/joy/Box'
import { TextPost } from './TextPost'
import List from '@mui/joy/List'
import ListDivider from '@mui/joy/ListDivider'

export const TextPostList = ({ onItemClick, onDelete, messages, activeId }) => {
    const handleItemClick = (id) => {
        onItemClick(id)
    }

    let txtPosts = Object.keys(messages).map((key) => {
        let item = messages[key]
        return (
            <div key={key}>
                <TextPost
                    message={item.message}
                    isScheduled={item.postData !== null}
                    onClick={handleItemClick}
                    selected={key === activeId}
                    id={key}
                    onDelete={onDelete}
                />
                <ListDivider sx={{ m: 0 }} />
            </div>
        )
    })
    return (
        <Box
            sx={{
                height: '100%',
                overflow: 'auto',
            }}
        >
            <List>{txtPosts}</List>
        </Box>
    )
}
